var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-container',[_c('b-img',{attrs:{"fluid":"","center":"","alt":"South Dakota Mines logo","src":require('./assets/sig-logo.png'),"id":"logo"}}),_vm._v(" "),_c('Intro'),_vm._v(" "),_c('SignatureForm'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Instructions')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bd9a8dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 